import PhotoSwipeLightbox from 'photoswipe/lightbox';
// noinspection TypeScriptCheckImport
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';
import 'photoswipe/style.css';
import 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css';
import '../styles/photoswipe.css';

export class Gallery {
	private instances: Array<{
		photoswipe: PhotoSwipeLightbox,
		captionPlugin: PhotoSwipeDynamicCaption,
	}> = [];

	constructor(
					private gallerySelector: string,
	) {
		this.init();
	}

	private init(): void {
		document.querySelectorAll<HTMLElement>(this.gallerySelector)
						.forEach(gallery => {
							const linkItems = gallery.querySelectorAll<HTMLAnchorElement>('a');

							const photoswipe = new PhotoSwipeLightbox({
								gallery: gallery,
								children: linkItems,
								pswpModule: () => import('photoswipe'),
							});

							const captionPlugin = new PhotoSwipeDynamicCaption(photoswipe, {
								// Plugins options, for example:
								type: 'auto',
							});

							photoswipe.init();

							this.instances.push({
								photoswipe,
								captionPlugin,
							});
						});
	}

	private tearDown(): void {
		for (const {photoswipe, captionPlugin} of this.instances) {
			photoswipe.destroy();
		}

		this.instances = [];
	}
}

export let gallery: Gallery | undefined;

document.addEventListener('DOMContentLoaded', () => {
	gallery = new Gallery('.gallery');
});
